import React, { Fragment } from 'react';

import { Icon } from 'office-ui-fabric-react/lib/Icon';

// const config = require(`../../../@${process.env.REACT_APP_TENANT}/config.js`)
//   .default;

const DocRequiredInfoList = ({
  requiredDocumentTypes,
  uploadedDocumentTypes,
  t,
}) => {
  return (
    <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
      {requiredDocumentTypes.map((documentType) => (
        <li key={documentType}>
          <Icon
            iconName={
              uploadedDocumentTypes.includes(documentType)
                ? 'CheckboxComposite'
                : 'Checkbox'
            }
          />{' '}
          {t(`documenttype::${documentType}`)}
        </li>
      ))}
    </ul>
  );
};

const DocRequiredInfo = ({ sale, offerData, docs, t, config }) => {
  const requiredDocumentTypes = config.getRequiredDocumentTypes(
    sale,
    offerData
  );
  const uploadedDocumentTypes = docs.map((doc) => doc.type);
  return (
    <Fragment>
      {Array.isArray(requiredDocumentTypes) &&
        requiredDocumentTypes.length > 0 && (
          <Fragment>
            <div>{t('Upload following documents')}:</div>
            <DocRequiredInfoList
              requiredDocumentTypes={requiredDocumentTypes}
              uploadedDocumentTypes={uploadedDocumentTypes}
              t={t}
            />
          </Fragment>
        )}
      {!Array.isArray(requiredDocumentTypes) &&
        Object.keys(requiredDocumentTypes).length > 0 && (
          <Fragment>
            <div style={{ marginBottom: '10px' }}>
              {t('Upload following documents')}:
            </div>
            {Object.keys(requiredDocumentTypes).map((key) => (
              <Fragment key={key}>
                <div>
                  <strong>{t(`section__${key}`)}</strong>
                </div>
                <DocRequiredInfoList
                  requiredDocumentTypes={requiredDocumentTypes[key]}
                  uploadedDocumentTypes={uploadedDocumentTypes}
                  t={t}
                />
              </Fragment>
            ))}
          </Fragment>
        )}
    </Fragment>
  );
};

export default DocRequiredInfo;



// WEBPACK FOOTER //
// ./src/app/containers/Sale/SaleEditSection/DocRequiredInfo.jsx